'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';
import { useMemo } from 'react';
import { FeedCarousel } from '@/components/ui/feed-carousel';
import { ExampleCard, contentToDemandExample } from '@/components/demand/ExampleCard';
import { useContentDetailSheet } from '@/lib/hooks/useContentDetailSheet';
import { useContentList } from '@/lib/hooks/useContent';
import type { ApiContent } from '@/lib/api/types';
const MAX_ITEMS = 5;
export function InspirationFeedSection() {
  const $ = _c(18);
  const {
    showContentDetail
  } = useContentDetailSheet();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      type: ["inspiration", "case-study"],
      status: "published",
      limit: MAX_ITEMS
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data
  } = useContentList(t0);
  let t1;
  if ($[1] !== data?.pages?.[0]?.content) {
    t1 = data?.pages?.[0]?.content ?? [];
    $[1] = data?.pages?.[0]?.content;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = t1.slice(0, MAX_ITEMS);
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const items = t2;
  if (items.length === 0) {
    return null;
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mx-auto max-w-[1320px] px-5 sm:px-8 lg:px-12"><div className="mb-2"><h2 className="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl">Get Inspired. Make your Next Moves.</h2></div><p className="text-lg text-gray-500 mb-8 max-w-2xl">Browse real world examples from all over the world of what other brands and businesses are doing to get attention, grow demand and drive sales.</p></div>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="max-w-7xl mx-auto mt-12 px-4 sm:px-6 lg:px-8"><h3 className="text-xl font-bold tracking-tight text-gray-900">Hot Inspiration 👇</h3></div>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      href: "/inspiration-feed",
      label: "Explore More Inspiration"
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== items || $[9] !== showContentDetail) {
    let t7;
    if ($[11] !== showContentDetail) {
      t7 = content => <ExampleCard key={content.id} variant="intelligence" example={contentToDemandExample(content)} detailMode="sheet" onOpen={() => showContentDetail(content)} moreDetailsLabel="Details" demandFacets={["objective", "tactic", "channel"]} showHighlights={true} showHighlightDetails={false} />;
      $[11] = showContentDetail;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    t6 = items.map(t7);
    $[8] = items;
    $[9] = showContentDetail;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <div className="mx-auto max-w-[1320px]"><FeedCarousel className="mt-8" exploreMore={t5}>{t6}</FeedCarousel></div>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="mx-auto mt-10 max-w-[1320px] px-5 text-center sm:px-8 lg:px-12"><Link href="/inspiration-feed" className="inline-flex cursor-pointer items-center gap-2 rounded-full bg-[#ff5a36] px-7 py-3.5 text-base font-black text-white shadow-lg shadow-red-500/20 transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-red-500/30">View all Inspiration<ArrowRight className="h-4 w-4" aria-hidden="true" /></Link></div>;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7) {
    t9 = <section className="relative overflow-hidden bg-white py-16 sm:py-20 lg:py-24">{t3}{t4}{t7}{t8}</section>;
    $[16] = t7;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}